import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export type OrderAtomType = {
  status: { fetch: StatusType, create: StatusType, update: StatusType, delete: StatusType, cancel: StatusType, receipt: StatusType };
  list: Array<object>;
  data: object;
  error: object;
}

export const orderAtom = atom<OrderAtomType>({
  key: 'orderAtom',
  default: {
    status: {
      fetch: 'idle',
      create: 'idle',
      update: 'idle',
      delete: 'idle',
      cancel: 'idle',
      receipt: 'idle'
    },
    list: [],
    data: {},
    error: {}
  },
});

// ======================================================

type Status = 'idle' | 'loading' | 'success' | 'error';

export interface OrderActionStatusAtom {
  searchList: Status,
  fetchList: Status,
  fetch: Status,
  create: Status,
  update: Status,
  delete: Status,
}

export const orderActionStatusAtom = atom<OrderActionStatusAtom>({
  key: 'orderActionStatusAtom',
  default: {
    searchList: 'idle',
    fetchList: 'idle',
    fetch: 'idle',
    create: 'idle',
    update: 'idle',
    delete: 'idle',
  }
});

export const orderResultAtom = atom({
  key: 'orderResultAtom',
  default: []
})

export const orderListAtom = atom({
  key: 'orderListAtom',
  default: []
})

export const orderDetailsAtom = atom({
  key: 'orderDetailsAtom',
  default: {}
})

export const orderErrorAtom = atom({
  key: 'orderErrorAtom',
  default: {}
})

export type ProfileAtomType = {
  status: { fetch: StatusType, create: StatusType, update: StatusType, delete: StatusType };
  list: object;
  data: object;
  error: object;
}


export const profileAtom = atom<ProfileAtomType>({
  key: 'profileAtom',
  default: {
    status: {
      fetch: 'idle',
      create: 'idle',
      update: 'idle',
      delete: 'idle',
    },
    list: {},
    data: {},
    error: {}
  }
});



export type CartAtomType = {
  status: { fetch: StatusType, create: StatusType, update: StatusType, delete: StatusType };
  list: object;
  data: object;
  error: object;
}


export const CartAtom = atom<CartAtomType>({
  key: 'cartAtom',
  default: {
    status: {
      fetch: 'idle',
      create: 'idle',
      update: 'idle',
      delete: 'idle',
    },
    list: {},
    data: {},
    error: {}
  }
});


